import {
  VariableSelectionDetails,
  VariableWithSelectionPayload,
} from './selectionDetails.typing'

function isSelectionDetails(value: unknown): value is VariableSelectionDetails {
  return Boolean(
    value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      typeof (value as { kind?: unknown }).kind === 'string',
  )
}

export function getVariableSelectionDetails(
  variable: VariableWithSelectionPayload,
): VariableSelectionDetails | null {
  if (isSelectionDetails(variable.payload?.selectionDetails)) {
    return variable.payload.selectionDetails.description || !variable.description
      ? variable.payload.selectionDetails
      : {
          ...variable.payload.selectionDetails,
          description: variable.description,
        }
  }

  if (!variable.description) {
    return null
  }

  return {
    kind: 'generic',
    description: variable.description,
  }
}
